import { LazyPage } from '../../components/loadable';

export const SynClassPage = LazyPage(import('./sync-class'))
export const SyncHocSinhPage = LazyPage(import('./sync-hocsinh'))